import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useCart } from "../../context/CartContext";
import Step1Login from "./Step1Login/Step1Login";
import Step2Address from "./Step2Address/Step2Address";
import Step3Shipping from "./Step3Shipping/Step3Shipping";
import Step4Payment from "./Step4Payment/Step4Payment";
import "./Checkout.css";
import CheckoutStepper from "./CheckoutStepper/CheckoutStepper";

const CHECKOUT_STEPS = {
  // LOGIN: 1,
  ADDRESS: 1,
  SHIPPING: 2,
  PAYMENT: 3,
};

export default function Checkout() {
  const navigate = useNavigate();

  const { user } = useAuth();
  const { cart } = useCart();

  const [step, setStep] = useState(CHECKOUT_STEPS.ADDRESS);

  useEffect(() => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
}, [step]);

  const [checkoutData, setCheckoutData] = useState({
    address: null,
    shipping: null,
    payment: null,
    comment: "",
  });



  const goToStep = (nextStep) => {
    setStep(nextStep);
  };

  const updateCheckoutData = (data) => {
    setCheckoutData((previousData) => ({
      ...previousData,
      ...data,
    }));
  };

  if (!cart || cart.length === 0) {
    return (
      <div className="checkout-empty">
        <h2>سبد خرید شما خالی می باشد</h2>

        <button onClick={() => navigate("/")}>ادامه خرید</button>
      </div>
    );
  }







  return (
    
    <div className="checkout-page">

      <CheckoutStepper
        currentStep={step}
      />


      {/* 
      {step === CHECKOUT_STEPS.LOGIN && (
        <Step1Login
          user={user}
          onContinue={() => goToStep(CHECKOUT_STEPS.ADDRESS)}
        />
      )} */}


      {step === CHECKOUT_STEPS.ADDRESS && (
        <Step2Address

          selectedAddress={
            checkoutData.address
          }

          onAddressSelected={(address) => {
            updateCheckoutData({
              address,
            });
          }}

          onContinue={(data) => {

            updateCheckoutData({

              address: data.address,

              comment: data.comment,

              /*
              Address changed =>
              previous shipping is no longer valid
              */

              shipping: null,

              payment: null,
            });

            goToStep(
              CHECKOUT_STEPS.SHIPPING
            );
          }}

          onBack={() => {
            navigate("/cart");
          }}
        />
      )}


      {/* ============================================================
                STEP 2 - SHIPPING
            ============================================================ */}





      {step === CHECKOUT_STEPS.SHIPPING && (
        <Step3Shipping

          comment={checkoutData.comment || ""}
          setComment={(value) =>
            updateCheckoutData({
              comment: value,
            })
          }

          selectedAddress={
            checkoutData.address
          }

          shippingData={
            checkoutData.shipping
          }



          onShippingSelected={(shipping) => {

            updateCheckoutData({
              shipping,
            });

            goToStep(
              CHECKOUT_STEPS.PAYMENT
            );

          }}

          onBack={() =>
            goToStep(
              CHECKOUT_STEPS.ADDRESS
            )
          }

        />
      )}

      {step === CHECKOUT_STEPS.PAYMENT && (
        <Step4Payment
          checkoutData={checkoutData}
          onBack={() => goToStep(CHECKOUT_STEPS.SHIPPING)}
          cart={cart}
          selectedAddress={checkoutData.address}
          selectedShipping={checkoutData.shipping}
          comment={checkoutData.comment}
          //  onNext={handlePayment}
          onNext={() => { }}
        />
      )}
    </div>
  );
}
